import { RegexValidator } from "./RegexValidator";

export class EmptyValidator extends RegexValidator {
  constructor(validatorMessage: string = "This field should not be empty.") {
    const emptyRegex = /^\s*(?:\S\s*){1,}$/;
    super(emptyRegex, validatorMessage);
  }
}
